var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseEnterySizeWise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M418.145 121.14 335.285 204H392c11.047 0 20 8.953 20 20s-8.953 20-20 20h-75c-27.57 0-50-22.43-50-50v-75c0-11.047 8.953-20 20-20s20 8.953 20 20v56.715l82.855-82.856c7.813-7.812 20.477-7.812 28.286 0 7.812 7.809 7.812 20.473.004 28.282zM226 410c11.047 0 20-8.953 20-20v-75c0-27.57-22.43-50-50-50h-75c-11.047 0-20 8.953-20 20s8.953 20 20 20h56.715l-82.86 82.86c-7.808 7.808-7.808 20.472 0 28.28 3.907 3.907 9.028 5.86 14.145 5.86s10.238-1.953 14.145-5.86L206 333.286V390c0 11.047 8.953 20 20 20zm266-58c11.047 0 20-8.953 20-20V80c0-44.113-35.887-80-80-80H80C35.887 0 0 35.887 0 80v352c0 44.113 35.887 80 80 80h352c44.113 0 80-35.887 80-80 0-11.047-8.953-20-20-20s-20 8.953-20 20c0 22.055-17.945 40-40 40H80c-22.055 0-40-17.945-40-40V80c0-22.055 17.945-40 40-40h352c22.055 0 40 17.945 40 40v252c0 11.047 8.953 20 20 20zm0 0",
    fill: "#999999",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseEnterySizeWise);
export default __webpack_public_path__ + "static/media/purchase-entery-size-wise.08092bbbc1a4b7e8f6e163878230cdcf.svg";
export { ForwardRef as ReactComponent };